import { render, staticRenderFns } from "./AdminLogIn.vue?vue&type=template&id=31a88e68"
import script from "./AdminLogIn.vue?vue&type=script&lang=js"
export * from "./AdminLogIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports